import type { Tutorial } from '../../shared/types.js';

export const blueprintsOverviewTutorial: Tutorial = {
  name: 'blueprints-overview',
  title: 'Introduction to the Blueprints page',
  description:
    'A quick tour of where your blueprints live, how they group into Base and your own, and how to start building a new one.',
  category: 'blueprints',
  docPages: ['concepts/blueprints'],
  agenda: ['Browse your blueprints', 'Find a specific blueprint', 'Build a new blueprint'],
  steps: [
    {
      id: 'intro',
      kind: 'info',
      title: 'Welcome to Blueprints',
      body: "A blueprint is a prebuilt devbox image - the OS, packages, repositories, and setup commands an agent starts from. This page is where you browse, inspect, and build them. Let's take a look around.",
      path: '/configure/build/environments',
    },
    {
      id: 'sidebar',
      kind: 'info',
      title: 'Your blueprints',
      body: 'Every blueprint lives in this list, split into two groups: **Base**, the host-managed foundation every org has, and **Blueprints**, your own. Click any one to inspect its image layers, commands, and build logs.',
      target: '[data-tutorial-id="blueprint-sidebar"]',
      placement: 'right',
    },
    {
      id: 'filters',
      kind: 'info',
      title: 'Find a specific blueprint',
      body: 'Filter the list by build status - **Building**, **Ready**, or **Failed** - to jump straight to the blueprint you need.',
      target: '[data-tutorial-id="blueprint-filter-bar"]',
      placement: 'bottom',
    },
    {
      id: 'new',
      kind: 'info',
      title: 'Build a new blueprint',
      body: 'This is where every blueprint begins - the **New blueprint** button opens the **New Repo Image** flow: point it at a GitHub repo and Reflex builds an image on your base with the repo cloned in. It has its own guided tour, worth taking.',
      target: '[data-tutorial-id="blueprint-new"]',
      placement: 'left',
    },
    {
      id: 'done',
      kind: 'info',
      title: "That's the tour",
      body: 'You know your way around now. Next, get to know the `base` blueprint everything builds on - or jump straight to building a repo image.',
    },
  ],
  handoff: { tutorialName: 'base-blueprints', label: 'Learn about base blueprints' },
  related: [{ tutorialName: 'blueprints', label: 'Build a repo image' }],
};
